module.exports = __webpack_public_path__ + "img/上下翻转.95c4f524.svg";